import { Location } from '~/types/booking'

export default function isLocationPhysical(location: Location | null | undefined): boolean {
  return Boolean(location) && location !== Location.ONLINE
}
